import { useEffect } from "react";
import { makeStyles } from "tss-react/mui";
import { z } from "zod";
import { MiDetailFields, MiDetailPageHeader } from "@miplatform/components";
import { useEdit, useRouter } from "@miplatform/hooks";
import { mdiChevronLeft } from "@mdi/js";
import { Footer } from "@mibuildweb/components";
import { Box } from "@mui/material";
import { useTitleDetailsViewModel } from "./useTitleDetailsViewModel";

const useStyles = makeStyles()((theme) => ({
  container: {
    height: "inherit",
    overflowY: "scroll",
    margin: 5,
    borderRadius: 10,
    padding: 20,
    backgroundColor: theme.palette.common.white,
  },
  contentContainer: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    height: "inherit",
  },
}));

export function TitleDetails() {
  const route = useRouter();
  const { id: titleId } = route.params;

  const { getTitle, updateTitle, stateManager, title } =
    useTitleDetailsViewModel();

  const { classes } = useStyles();

  useEffect(() => {
    getTitle(titleId);
  }, []);

  const onUpdate = () => {
    updateTitle(
      titleId,
      { ...edit.edits, modifiedOn: edit.getValue("modifiedOn") },
      () => {
        getTitle(titleId);
      }
    );
  };

  const detailFields = [
    {
      label: "Title Name",
      name: "name",
      required: true,
      width: "25%",
      flexGrow: 0,
      validationRule: z
        .string()
        .min(2, "Title name is too short")
        .max(255, "Title name is too long"),
    },
    {
      label: "Description",
      name: "description",
      required: true,
      width: "100%",
    },
  ];

  const edit = useEdit(title, detailFields);

  return (
    <div className={classes.contentContainer}>
      <MiDetailPageHeader
        title={`Title: ${title?.name || ""}`}
        titleIcon={mdiChevronLeft}
        loading={stateManager.isBusy()}
      />
      <Box className={classes.container}>
        <MiDetailFields
          detailFields={detailFields}
          headerProps={{
            icon: "mdiFormatListBulleted",
            title: "Detail Fields",
          }}
          edit={edit}
        />
      </Box>
      <Footer
        show={edit.isDirty()}
        handleSaveClick={onUpdate}
        handleCancelClick={() => edit.reset()}
        disableSave={edit.errors || stateManager.isBusy()}
      />
    </div>
  );
}
